import React, { Component } from 'react'
import { ScrollView, FlatList } from 'react-native'

// import styles from './styles'
import { HGView, HGHeading } from '../../components/HGUI'

class StartOverviewCaredependentsScreen extends Component {
  render() {
    return (
      <ScrollView>
        <HGView>
          <HGHeading>StartOverviewCaredependents</HGHeading>
        </HGView>
      </ScrollView>
    )
  }
}

export default StartOverviewCaredependentsScreen
